import { render, staticRenderFns } from "./SysMenuEdit.vue?vue&type=template&id=a87806a8&scoped=true&"
import script from "./SysMenuEdit.vue?vue&type=script&lang=js&"
export * from "./SysMenuEdit.vue?vue&type=script&lang=js&"
import style0 from "./SysMenuEdit.vue?vue&type=style&index=0&id=a87806a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87806a8",
  null
  
)

export default component.exports